'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DocumentModeCanvasColumnDebugger = require('./DocumentModeCanvasColumnDebugger');

var _DocumentModeCanvasColumnDebugger2 = _interopRequireDefault(_DocumentModeCanvasColumnDebugger);

var _DocumentModeCanvasReadingLineDebugger = require('./DocumentModeCanvasReadingLineDebugger');

var _DocumentModeCanvasReadingLineDebugger2 = _interopRequireDefault(_DocumentModeCanvasReadingLineDebugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentModeCanvasClusterDebugger = function DocumentModeCanvasClusterDebugger(_ref) {
    var gridSize = _ref.gridSize,
        clusterIndex = _ref.clusterIndex,
        clusterData = _ref.clusterData,
        elementOrder = _ref.elementOrder;

    var columnReadingLines = clusterData.get('readingData');
    var columnsData = clusterData.get('children');

    return _react2.default.createElement(
        'div',
        { className: 'DocumentModeCanvasClusterDebugger' },
        columnsData.map(function (columnClusterData, index) {
            return _react2.default.createElement(_DocumentModeCanvasColumnDebugger2.default, {
                key: index,
                gridSize: gridSize,
                clusterIndex: clusterIndex,
                columnIndex: index + 1,
                columnData: columnClusterData,
                elementOrder: elementOrder });
        }),
        columnReadingLines.map(function (readingLine, index) {
            return _react2.default.createElement(_DocumentModeCanvasReadingLineDebugger2.default, _extends({
                className: 'column',
                key: index,
                gridSize: gridSize,
                order: index + 1
            }, readingLine.toJS()));
        })
    );
};

DocumentModeCanvasClusterDebugger.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    clusterIndex: _propTypes2.default.number.isRequired,
    clusterData: _propTypes2.default.object.isRequired,
    elementOrder: _propTypes2.default.object.isRequired
};

exports.default = DocumentModeCanvasClusterDebugger;


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/DocumentModeCanvasClusterDebugger.js
// module id = 1940
// module chunks = 0